import { WifiOff } from 'lucide-react'

export default function OfflineIndicator() {
  return (
    <div className="offline-indicator flex items-center justify-center gap-2">
      <WifiOff className="h-4 w-4" />
      <span>You are offline. Changes will be synced when you reconnect.</span>
    </div>
  )
}
